export const LOGO_REVELATEUR = "https://customer-assets-4nw71qhi.emergentagent.net/job_rapport-strategique/artifacts/xnlbarmm_LE_REVELATEUR_logo%20transparent.png";
export const LOGO_R_HEADER = "https://customer-assets-4nw71qhi.emergentagent.net/job_rapport-strategique/artifacts/0fn1lsfo_SYMBOLE%20SEUL.png";
export const LOGO_MB = "https://customer-assets-4nw71qhi.emergentagent.net/job_rapport-strategique/artifacts/svhrk6uw_MB_LOGO_250KB.png";
export const CARD_FRONT = "https://customer-assets-4nw71qhi.emergentagent.net/job_rapport-strategique/artifacts/rbn4ygy7_1.png";
export const CARD_BACK = "https://customer-assets-4nw71qhi.emergentagent.net/job_rapport-strategique/artifacts/nrxrckmv_2.png";

export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const SECTORS = [
  "Services professionnels", "Commerce de détail", "Restauration & hospitalité",
  "Manufacturier", "Construction & immobilier", "Santé & bien-être",
  "Technologie & numérique", "Marketing & communication", "Finance & assurance",
  "Éducation & formation", "Arts & culture", "Autre",
];
export const SIZES = ["Solo / travailleur autonome", "2 à 5 personnes", "6 à 20 personnes", "21 à 50 personnes", "51 à 200 personnes", "Plus de 200 personnes"];
